import { render, staticRenderFns } from "./FullScreenCardRight.vue?vue&type=template&id=2799a3cc&scoped=true"
import script from "./FullScreenCardRight.vue?vue&type=script&lang=js"
export * from "./FullScreenCardRight.vue?vue&type=script&lang=js"
import style0 from "./FullScreenCardRight.vue?vue&type=style&index=0&id=2799a3cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2799a3cc",
  null
  
)

export default component.exports